import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  GenericScalar: any,
  JSON: any,
}

export interface IBaseIncentive {
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly createdAt: Scalars['String'],
  readonly updatedAt: Scalars['String'],
  readonly startDate: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly maxRedemptionsDuration: Maybe<Scalars['String']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
}

export interface IBenefit {
  readonly type: BenefitType,
}

export interface IBenefitReference  extends IBenefit {
  readonly __typename?: 'BenefitReference',
  readonly type: BenefitType,
  readonly value: Scalars['String'],
}

export interface IBenefitSwap  extends IBenefit {
  readonly __typename?: 'BenefitSwap',
  readonly type: BenefitType,
  readonly value: ISwap,
}

export enum BenefitType {
  REFERENCE = 'REFERENCE',
  SWAP = 'SWAP'
}

export interface ICartEntryInput {
  readonly lineId?: Maybe<Scalars['String']>,
  readonly sanityId: Scalars['String'],
  readonly price?: Maybe<Scalars['Int']>,
  readonly quantity: Scalars['Int'],
  readonly children?: Maybe<ReadonlyArray<ICartEntryInput>>,
}

export interface ICoupon {
  readonly __typename?: 'Coupon',
  readonly code: Scalars['String'],
  readonly isValid: Scalars['Boolean'],
  readonly message: Scalars['String'],
  readonly reason: Maybe<Scalars['String']>,
  readonly offerId: Maybe<Scalars['String']>,
  readonly isRedeemed: Maybe<Scalars['Boolean']>,
  readonly shouldRedeem: Maybe<Scalars['Boolean']>,
}

export interface IEvaluatedIncentives {
  readonly __typename?: 'EvaluatedIncentives',
  readonly invalidOffers: ReadonlyArray<IInvalidIncentives>,
  readonly invalidRewards: ReadonlyArray<IInvalidIncentives>,
}

export interface IEvaluateIncentivesInput {
  readonly appliedIncentives: ReadonlyArray<IPromotionInput>,
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntryInput>>,
  readonly paymentMethod?: Maybe<PaymentMethod>,
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export interface IExternalIdentifier {
  readonly __typename?: 'ExternalIdentifier',
  readonly type: Scalars['String'],
  readonly value: Scalars['String'],
}


export interface IInRestaurantIncentive {
  readonly __typename?: 'InRestaurantIncentive',
  readonly id: Scalars['ID'],
  readonly type: InRestaurantIncentiveType,
}

export interface IInRestaurantIncentiveInput {
  readonly id: Scalars['ID'],
  readonly type: InRestaurantIncentiveType,
}

export enum InRestaurantIncentiveType {
  REWARD = 'REWARD',
  OFFER = 'OFFER',
  LEGACY_OFFER = 'LEGACY_OFFER'
}

export interface IInRestaurantOrderLineItem {
  readonly incentive?: Maybe<IInRestaurantIncentiveInput>,
  readonly quantity: Scalars['Int'],
  readonly referenceId: Scalars['ID'],
  readonly vendorConfigs: IVendorConfigsInput,
}

export interface IInRestaurantOrderLineItemType {
  readonly __typename?: 'InRestaurantOrderLineItemType',
  readonly incentive: Maybe<IInRestaurantIncentive>,
  readonly quantity: Scalars['Int'],
  readonly referenceId: Scalars['ID'],
  readonly vendorConfigs: IVendorConfigs,
}

export interface IInvalidIncentives {
  readonly __typename?: 'InvalidIncentives',
  readonly errors: ReadonlyArray<IRuleConditionEvaluation>,
  readonly id: Scalars['ID'],
}


export enum Language {
  EN = 'EN',
  ES = 'ES',
  FR = 'FR'
}

export interface IMutation {
  readonly __typename?: 'Mutation',
  readonly _empty: Maybe<Scalars['String']>,
  readonly generateOtp: IOtp,
  readonly processSmgCode: IProcessSmgCodeResponse,
  readonly createOrderlessTransaction: Maybe<Scalars['Boolean']>,
  readonly redeemPromoCode: Maybe<IRedeemedCoupon>,
  readonly validatePromoCode: Maybe<ICoupon>,
}


export interface IMutationGenerateOtpArgs {
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>,
  loyaltyId: Scalars['ID'],
  restaurantId: Maybe<Scalars['ID']>
}


export interface IMutationProcessSmgCodeArgs {
  loyaltyId: Scalars['ID'],
  smgCode: Scalars['String'],
  transactionDate: Maybe<Scalars['String']>
}


export interface IMutationCreateOrderlessTransactionArgs {
  input: IOrderlessTransactionInput
}


export interface IMutationRedeemPromoCodeArgs {
  code: Scalars['String'],
  cognitoId: Scalars['String']
}


export interface IMutationValidatePromoCodeArgs {
  code: Scalars['String'],
  cognitoId: Scalars['String'],
  shouldRedeem: Maybe<Scalars['Boolean']>,
  offers: ReadonlyArray<Scalars['String']>
}

export interface IObjectType {
  readonly __typename?: 'ObjectType',
  readonly key: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['JSON']>,
}

export interface IOffer  extends IBaseIncentive {
  readonly __typename?: 'Offer',
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly createdAt: Scalars['String'],
  readonly updatedAt: Scalars['String'],
  readonly startDate: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly maxRedemptionsDuration: Maybe<Scalars['String']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly redemptionType: Maybe<OfferRedemptionType>,
  readonly type: OfferType,
  readonly loyaltyId: Maybe<Scalars['ID']>,
  readonly benefits: Maybe<ReadonlyArray<IBenefit>>,
}

export enum OfferRedemptionType {
  PROMO_CODE = 'PROMO_CODE',
  STANDARD = 'STANDARD',
  SURPRISE = 'SURPRISE',
  SWAP = 'SWAP'
}

export interface IOffersInput {
  readonly appliedIncentives?: Maybe<ReadonlyArray<IPromotionInput>>,
  readonly appliedPromotions?: Maybe<ReadonlyArray<IPromotionInput>>,
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntryInput>>,
  readonly global?: Maybe<Scalars['Boolean']>,
  readonly redemptionTypes?: Maybe<ReadonlyArray<OfferRedemptionType>>,
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export enum OfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IOrderlessIncentiveInput {
  readonly id: Scalars['String'],
  readonly type: PromotionType,
  readonly metadata?: Maybe<Scalars['JSON']>,
}

export interface IOrderlessTransactionInput {
  readonly cognitoId?: Maybe<Scalars['String']>,
  readonly loyaltyId?: Maybe<Scalars['String']>,
  readonly channel: Scalars['String'],
  readonly storeId?: Maybe<Scalars['String']>,
  readonly incentives: ReadonlyArray<IOrderlessIncentiveInput>,
}

export enum OrderSelectionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING'
}

export interface IOrderSelectionTransfer {
  readonly __typename?: 'OrderSelectionTransfer',
  readonly createdAt: Scalars['String'],
  readonly expiry: Maybe<Scalars['Int']>,
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly order: ReadonlyArray<IInRestaurantOrderLineItemType>,
  readonly otp: Scalars['String'],
  readonly restaurantId: Maybe<Scalars['String']>,
  readonly updatedAt: Maybe<Scalars['String']>,
  readonly status: Maybe<OrderSelectionStatus>,
}

export interface IOtp {
  readonly __typename?: 'Otp',
  readonly password: Scalars['String'],
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu',
  readonly plu: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
}

export interface IParentChildPluInput {
  readonly plu?: Maybe<Scalars['String']>,
  readonly childPlu?: Maybe<Scalars['String']>,
}

export interface IPayment {
  readonly __typename?: 'Payment',
  readonly amount: Scalars['Int'],
  readonly description: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly token: Maybe<Scalars['String']>,
  readonly expiration: Maybe<IPaymentExpiration>,
}

export interface IPaymentExpiration {
  readonly __typename?: 'PaymentExpiration',
  readonly month: Maybe<Scalars['Int']>,
  readonly year: Maybe<Scalars['Int']>,
}

export enum PaymentMethod {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERSCLUB = 'DINERSCLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA'
}

export interface IPerson {
  readonly __typename?: 'Person',
  readonly externalIds: Maybe<ReadonlyArray<Maybe<IExternalIdentifier>>>,
  readonly phone: Maybe<Scalars['String']>,
  readonly email: Maybe<Scalars['String']>,
}

export interface IPickupContact {
  readonly __typename?: 'PickupContact',
  readonly name: Maybe<Scalars['String']>,
  readonly phone: Maybe<Scalars['String']>,
  readonly hasArrived: Scalars['Boolean'],
  readonly vehicle: Maybe<IPickupContactVehicle>,
}

export interface IPickupContactVehicle {
  readonly __typename?: 'PickupContactVehicle',
  readonly make: Maybe<Scalars['String']>,
  readonly model: Maybe<Scalars['String']>,
  readonly color: Maybe<Scalars['String']>,
  readonly licensePlate: Maybe<Scalars['String']>,
}

export interface IPosVendor {
  readonly __typename?: 'PosVendor',
  readonly id: Maybe<Scalars['String']>,
  readonly type: Scalars['String'],
  readonly transactionId: Scalars['String'],
}

export interface IProcessSmgCodeResponse {
  readonly __typename?: 'ProcessSmgCodeResponse',
  readonly pointsEarned: Scalars['Int'],
  readonly status: SmgCodeStatus,
}

export interface IPromotion {
  readonly __typename?: 'Promotion',
  readonly id: Scalars['String'],
  readonly lineId: Maybe<Scalars['String']>,
  readonly type: PromotionType,
}

export interface IPromotionInput {
  readonly id: Scalars['String'],
  readonly lineId?: Maybe<Scalars['String']>,
  readonly swap?: Maybe<IPromotionSwapInput>,
  readonly type: PromotionType,
}

export interface IPromotionsInput {
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export interface IPromotionSwapInput {
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
  readonly type: SwapType,
  readonly lineId: Scalars['String'],
}

export enum PromotionType {
  OFFER = 'OFFER',
  REWARD = 'REWARD',
  SYSTEMWIDE_PROMOTION = 'SYSTEMWIDE_PROMOTION'
}

export interface IQuantityPlu {
  readonly __typename?: 'QuantityPlu',
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Int']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface IQuantityPluInput {
  readonly qualifier?: Maybe<Scalars['String']>,
  readonly quantity?: Maybe<Scalars['Int']>,
  readonly plu?: Maybe<Scalars['String']>,
}

export interface IQuery {
  readonly __typename?: 'Query',
  readonly getSanityMenu: Maybe<Scalars['GenericScalar']>,
  readonly upsellRecommendations: IRecommendations,
  readonly _empty: Maybe<Scalars['String']>,
  readonly loyaltyOffers: Maybe<ReadonlyArray<IOffer>>,
  readonly orderSelection: Maybe<IOrderSelectionTransfer>,
  readonly loyaltyRewards: Maybe<ReadonlyArray<IReward>>,
  readonly loyaltyUser: Maybe<IUser>,
}


export interface IQueryUpsellRecommendationsArgs {
  type: RecommendationType,
  limit?: Maybe<Scalars['Int']>,
  products: Maybe<ReadonlyArray<Maybe<IRecommendationProducts>>>,
  storeId: Maybe<Scalars['String']>,
  serviceMode: Maybe<Scalars['String']>
}


export interface IQueryLoyaltyOffersArgs {
  ids: Maybe<ReadonlyArray<Scalars['ID']>>,
  loyaltyId: Maybe<Scalars['ID']>,
  redemptionTypes: Maybe<ReadonlyArray<OfferRedemptionType>>,
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  subtotalAmount: Maybe<Scalars['Int']>
}


export interface IQueryOrderSelectionArgs {
  otp: Scalars['String']
}


export interface IQueryLoyaltyRewardsArgs {
  ids: Maybe<ReadonlyArray<Scalars['ID']>>,
  loyaltyId: Maybe<Scalars['ID']>,
  serviceMode: Maybe<ServiceMode>,
  storeId: Maybe<Scalars['String']>,
  subtotalAmount: Maybe<Scalars['Int']>
}


export interface IQueryLoyaltyUserArgs {
  loyaltyId: Scalars['ID']
}

export interface IRecommendationItem {
  readonly __typename?: 'RecommendationItem',
  readonly id: Scalars['String'],
}

export interface IRecommendationProductInput {
  readonly id: Scalars['String'],
  readonly quantity: Scalars['Int'],
}

export interface IRecommendationProducts {
  readonly id: Scalars['String'],
  readonly quantity: Scalars['Int'],
  readonly sublevelItems?: Maybe<ReadonlyArray<IRecommendationProductInput>>,
}

export interface IRecommendations {
  readonly __typename?: 'Recommendations',
  readonly recommender: Scalars['String'],
  readonly recommendationToken: Scalars['String'],
  readonly results: ReadonlyArray<IRecommendationItem>,
}

export enum RecommendationType {
  CART = 'CART',
  MENU = 'MENU',
  OTHER = 'OTHER'
}

export interface IRedeemedCoupon {
  readonly __typename?: 'RedeemedCoupon',
  readonly code: Scalars['String'],
  readonly isRedeemed: Scalars['Boolean'],
  readonly offerId: Maybe<Scalars['String']>,
  readonly message: Maybe<Scalars['String']>,
  readonly reason: Maybe<Scalars['String']>,
}

export interface IReward  extends IBaseIncentive {
  readonly __typename?: 'Reward',
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly createdAt: Scalars['String'],
  readonly updatedAt: Scalars['String'],
  readonly startDate: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly maxRedemptionsDuration: Maybe<Scalars['String']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly rewardBenefitId: Scalars['String'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<IObjectType>>>,
  readonly pointCost: Scalars['Int'],
  readonly limitPerOrder: Maybe<Scalars['Int']>,
  readonly loyaltyUserPoints: Maybe<Scalars['Int']>,
  readonly locked: Maybe<Scalars['Boolean']>,
  readonly redemptionPercentage: Maybe<Scalars['Int']>,
  readonly remainingPointsNeededForRedemption: Maybe<Scalars['Int']>,
}

export interface IRewardsInput {
  readonly appliedIncentives?: Maybe<ReadonlyArray<IPromotionInput>>,
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntryInput>>,
  readonly ignorePointBalance?: Maybe<Scalars['Boolean']>,
  readonly incentiveIds?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly rewardIds?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly serviceMode?: Maybe<ServiceMode>,
  readonly storeId?: Maybe<Scalars['String']>,
  readonly subtotalAmount?: Maybe<Scalars['Int']>,
}

export interface IRuleConditionEvaluation {
  readonly __typename?: 'RuleConditionEvaluation',
  readonly code: Scalars['String'],
  readonly currentValue: Maybe<Scalars['JSON']>,
  readonly message: Maybe<Scalars['String']>,
  readonly ruleId: Scalars['String'],
  readonly targetValue: Maybe<Scalars['JSON']>,
}

export enum ServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TAKEOUT = 'TAKEOUT'
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu',
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface ISizeBasedPluInput {
  readonly comboPlu?: Maybe<Scalars['String']>,
  readonly comboSize?: Maybe<Scalars['String']>,
}

export enum SmgCodeStatus {
  ACCEPTED = 'ACCEPTED',
  CODE_EXISTS = 'CODE_EXISTS',
  EXPIRED = 'EXPIRED',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_RESTAURANT = 'INVALID_RESTAURANT',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  NOT_FOUND = 'NOT_FOUND',
  RETRY_REQUESTED = 'RETRY_REQUESTED',
  TRANSACTION_CLAIMED = 'TRANSACTION_CLAIMED'
}

export interface ISwap {
  readonly __typename?: 'Swap',
  readonly type: SwapType,
  readonly from: Scalars['String'],
  readonly to: Scalars['String'],
}

export enum SwapType {
  UPSIZE = 'UPSIZE'
}

export interface ISystemWidePromotion  extends IBaseIncentive {
  readonly __typename?: 'SystemWidePromotion',
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly createdAt: Scalars['String'],
  readonly updatedAt: Scalars['String'],
  readonly startDate: Scalars['String'],
  readonly endDate: Scalars['String'],
  readonly startTime: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly maxRedemptionsLimit: Maybe<Scalars['Int']>,
  readonly maxRedemptionsDuration: Maybe<Scalars['String']>,
  readonly minimumSpend: Maybe<Scalars['Int']>,
  readonly pointMultiplier: Maybe<Scalars['Int']>,
  readonly bonusPoints: Maybe<Scalars['Int']>,
  readonly metadata: Maybe<Scalars['JSON']>,
}

export interface ITransaction {
  readonly __typename?: 'Transaction',
  readonly id: Scalars['ID'],
  readonly shortId: Scalars['String'],
  readonly status: TransactionStatus,
  readonly createdAt: Scalars['String'],
  readonly loyaltyId: Maybe<Scalars['String']>,
  readonly channel: Scalars['String'],
  readonly transactionDetails: Maybe<ITransactionDetails>,
  readonly dateUpdated: Maybe<Scalars['String']>,
  readonly additionalReferenceIds: Maybe<ReadonlyArray<ITransactionAdditionalReferenceId>>,
  readonly pointsEarned: Scalars['Int'],
  readonly bonusPointsEarned: Scalars['Int'],
  readonly pointsUsed: Scalars['Int'],
}

export interface ITransactionAdditionalReferenceId {
  readonly __typename?: 'TransactionAdditionalReferenceId',
  readonly id: Scalars['String'],
  readonly type: Scalars['String'],
  readonly description: Maybe<Scalars['String']>,
}

export interface ITransactionDetails {
  readonly __typename?: 'TransactionDetails',
  readonly person: Maybe<IPerson>,
  readonly posVendor: IPosVendor,
  readonly currency: Scalars['String'],
  readonly payments: ReadonlyArray<IPayment>,
  readonly fulfillment: ITransactionFulfillment,
  readonly pickupContact: Maybe<IPickupContact>,
  readonly orders: ReadonlyArray<ITransactionOrder>,
  readonly language: Maybe<Language>,
  readonly promotions: Maybe<ReadonlyArray<IPromotion>>,
}

export interface ITransactionFulfillment {
  readonly __typename?: 'TransactionFulfillment',
  readonly type: Scalars['String'],
  readonly autoRelease: Maybe<Scalars['Boolean']>,
}

export interface ITransactionOrder {
  readonly __typename?: 'TransactionOrder',
  readonly productId: Scalars['String'],
  readonly quantity: Scalars['Int'],
  readonly price: Scalars['Int'],
  readonly parentReferenceId: Maybe<Scalars['String']>,
}

export interface ITransactionsInput {
  readonly ids?: Maybe<ReadonlyArray<Scalars['ID']>>,
  readonly statuses?: Maybe<ReadonlyArray<TransactionStatus>>,
}

export enum TransactionStatus {
  VOID = 'VOID',
  CLAIMED = 'CLAIMED',
  UNCLAIMED = 'UNCLAIMED',
  PENDING = 'PENDING'
}

export interface IUser {
  readonly __typename?: 'User',
  readonly id: Scalars['ID'],
  readonly name: Maybe<Scalars['String']>,
  readonly email: Scalars['String'],
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly dateOfBirth: Maybe<Scalars['String']>,
  readonly points: Scalars['Int'],
  readonly metadata: Maybe<ReadonlyArray<Maybe<IObjectType>>>,
  readonly createdAt: Scalars['String'],
  readonly transactions: Maybe<ReadonlyArray<ITransaction>>,
  readonly rewards: Maybe<ReadonlyArray<IReward>>,
  readonly bestPromotion: Maybe<ISystemWidePromotion>,
  readonly promotions: Maybe<ReadonlyArray<ISystemWidePromotion>>,
  readonly offers: Maybe<ReadonlyArray<IOffer>>,
  readonly pointsExpiryDateKey: Maybe<Scalars['String']>,
  readonly evaluatedIncentives: IEvaluatedIncentives,
}


export interface IUserTransactionsArgs {
  where: Maybe<ITransactionsInput>
}


export interface IUserRewardsArgs {
  where: Maybe<IRewardsInput>
}


export interface IUserBestPromotionArgs {
  where: Maybe<IPromotionsInput>
}


export interface IUserPromotionsArgs {
  where: Maybe<IPromotionsInput>
}


export interface IUserOffersArgs {
  where: Maybe<IOffersInput>
}


export interface IUserEvaluatedIncentivesArgs {
  where: IEvaluateIncentivesInput
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig',
  readonly pluType: Maybe<Scalars['String']>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Int']>,
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>,
  readonly parentChildPlu: Maybe<IParentChildPlu>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>,
  readonly sizeBasedPlu: Maybe<ISizeBasedPlu>,
}

export interface IVendorConfigInput {
  readonly pluType?: Maybe<Scalars['String']>,
  readonly parentSanityId?: Maybe<Scalars['String']>,
  readonly pullUpLevels?: Maybe<Scalars['Int']>,
  readonly constantPlu?: Maybe<Scalars['String']>,
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>,
  readonly parentChildPlu?: Maybe<IParentChildPluInput>,
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPluInput>>>,
  readonly sizeBasedPlu?: Maybe<ISizeBasedPluInput>,
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs',
  readonly carrols: Maybe<IVendorConfig>,
  readonly carrolsDelivery: Maybe<IVendorConfig>,
  readonly hdx: Maybe<IVendorConfig>,
  readonly ncr: Maybe<IVendorConfig>,
  readonly ncrDelivery: Maybe<IVendorConfig>,
  readonly productNumber: Maybe<IVendorConfig>,
  readonly productNumberDelivery: Maybe<IVendorConfig>,
  readonly qdi: Maybe<IVendorConfig>,
  readonly qdiDelivery: Maybe<IVendorConfig>,
  readonly qst: Maybe<IVendorConfig>,
  readonly rpos: Maybe<IVendorConfig>,
  readonly rposDelivery: Maybe<IVendorConfig>,
  readonly sicom: Maybe<IVendorConfig>,
  readonly sicomDelivery: Maybe<IVendorConfig>,
  readonly tablet: Maybe<IVendorConfig>,
  readonly tabletDelivery: Maybe<IVendorConfig>,
}

export interface IVendorConfigsInput {
  readonly carrols?: Maybe<IVendorConfigInput>,
  readonly carrolsDelivery?: Maybe<IVendorConfigInput>,
  readonly hdx?: Maybe<IVendorConfigInput>,
  readonly ncr?: Maybe<IVendorConfigInput>,
  readonly ncrDelivery?: Maybe<IVendorConfigInput>,
  readonly productNumber?: Maybe<IVendorConfigInput>,
  readonly productNumberDelivery?: Maybe<IVendorConfigInput>,
  readonly qdi?: Maybe<IVendorConfigInput>,
  readonly qdiDelivery?: Maybe<IVendorConfigInput>,
  readonly qst?: Maybe<IVendorConfigInput>,
  readonly rpos?: Maybe<IVendorConfigInput>,
  readonly rposDelivery?: Maybe<IVendorConfigInput>,
  readonly sicom?: Maybe<IVendorConfigInput>,
  readonly sicomDelivery?: Maybe<IVendorConfigInput>,
  readonly tablet?: Maybe<IVendorConfigInput>,
  readonly tabletDelivery?: Maybe<IVendorConfigInput>,
}

export type IUpsellRecommendationsQueryVariables = {
  limit?: Maybe<Scalars['Int']>,
  products: ReadonlyArray<IRecommendationProducts>,
  storeId: Scalars['String'],
  serviceMode: Scalars['String'],
  type: RecommendationType
};


export type IUpsellRecommendationsQuery = { readonly __typename?: 'Query', readonly upsellRecommendations: { readonly __typename?: 'Recommendations', readonly recommender: string, readonly recommendationToken: string, readonly results: ReadonlyArray<{ readonly __typename?: 'RecommendationItem', readonly id: string }> } };

export type ITransactionFragment = { readonly __typename?: 'Transaction', readonly id: string, readonly shortId: string, readonly loyaltyId: Maybe<string>, readonly channel: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly status: TransactionStatus, readonly createdAt: string, readonly dateUpdated: Maybe<string>, readonly transactionDetails: Maybe<{ readonly __typename?: 'TransactionDetails', readonly currency: string, readonly language: Maybe<Language>, readonly promotions: Maybe<ReadonlyArray<{ readonly __typename?: 'Promotion', readonly type: PromotionType, readonly id: string }>>, readonly orders: ReadonlyArray<{ readonly __typename?: 'TransactionOrder', readonly productId: string, readonly quantity: number, readonly price: number, readonly parentReferenceId: Maybe<string> }>, readonly fulfillment: { readonly __typename?: 'TransactionFulfillment', readonly type: string, readonly autoRelease: Maybe<boolean> }, readonly posVendor: { readonly __typename?: 'PosVendor', readonly id: Maybe<string>, readonly type: string, readonly transactionId: string }, readonly pickupContact: Maybe<{ readonly __typename?: 'PickupContact', readonly name: Maybe<string>, readonly phone: Maybe<string>, readonly hasArrived: boolean, readonly vehicle: Maybe<{ readonly __typename?: 'PickupContactVehicle', readonly make: Maybe<string>, readonly model: Maybe<string>, readonly color: Maybe<string>, readonly licensePlate: Maybe<string> }> }>, readonly payments: ReadonlyArray<{ readonly __typename?: 'Payment', readonly amount: number, readonly description: Maybe<string>, readonly type: string, readonly token: Maybe<string>, readonly expiration: Maybe<{ readonly __typename?: 'PaymentExpiration', readonly month: Maybe<number>, readonly year: Maybe<number> }> }>, readonly person: Maybe<{ readonly __typename?: 'Person', readonly phone: Maybe<string>, readonly email: Maybe<string>, readonly externalIds: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ExternalIdentifier', readonly type: string, readonly value: string }>>> }> }>, readonly additionalReferenceIds: Maybe<ReadonlyArray<{ readonly __typename?: 'TransactionAdditionalReferenceId', readonly id: string, readonly type: string, readonly description: Maybe<string> }>> };

export type IRewardFragment = { readonly __typename?: 'Reward', readonly id: string, readonly rewardBenefitId: string, readonly name: string, readonly pointCost: number, readonly createdAt: string, readonly updatedAt: string, readonly startDate: string, readonly endDate: string, readonly locked: Maybe<boolean>, readonly redemptionPercentage: Maybe<number>, readonly limitPerOrder: Maybe<number>, readonly remainingPointsNeededForRedemption: Maybe<number>, readonly metadata: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ObjectType', readonly key: Maybe<string>, readonly value: Maybe<any> }>>> };

export type ILoyaltyUserFragment = { readonly __typename?: 'User', readonly id: string, readonly name: Maybe<string>, readonly email: string, readonly phoneNumber: Maybe<string>, readonly dateOfBirth: Maybe<string>, readonly points: number, readonly createdAt: string, readonly pointsExpiryDateKey: Maybe<string>, readonly metadata: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ObjectType', readonly key: Maybe<string>, readonly value: Maybe<any> }>>>, readonly bestPromotion: Maybe<{ readonly __typename?: 'SystemWidePromotion', readonly metadata: Maybe<any> }> };

export type IOffersFragment = { readonly __typename?: 'Offer', readonly id: string, readonly type: OfferType, readonly benefits: Maybe<ReadonlyArray<{ readonly __typename?: 'BenefitReference', readonly type: BenefitType, readonly reference: string } | { readonly __typename?: 'BenefitSwap', readonly type: BenefitType, readonly value: { readonly __typename?: 'Swap', readonly type: SwapType, readonly from: string, readonly to: string } }>> };

export type IInvalidIncentiveFragment = { readonly __typename?: 'InvalidIncentives', readonly id: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'RuleConditionEvaluation', readonly code: string, readonly currentValue: Maybe<any>, readonly message: Maybe<string>, readonly ruleId: string, readonly targetValue: Maybe<any> }> };

export type ILoyaltyUserQueryVariables = {
  loyaltyId: Scalars['ID']
};


export type ILoyaltyUserQuery = { readonly __typename?: 'Query', readonly loyaltyUser: Maybe<(
    { readonly __typename?: 'User' }
    & ILoyaltyUserFragment
  )> };

export type ILoyaltyUserTransactionsQueryVariables = {
  loyaltyId: Scalars['ID']
};


export type ILoyaltyUserTransactionsQuery = { readonly __typename?: 'Query', readonly loyaltyUser: Maybe<{ readonly __typename?: 'User', readonly id: string, readonly transactions: Maybe<ReadonlyArray<(
      { readonly __typename?: 'Transaction' }
      & ITransactionFragment
    )>> }> };

export type ILoyaltyUserRewardsQueryVariables = {
  loyaltyId: Scalars['ID'],
  where?: Maybe<IRewardsInput>
};


export type ILoyaltyUserRewardsQuery = { readonly __typename?: 'Query', readonly loyaltyUser: Maybe<{ readonly __typename?: 'User', readonly id: string, readonly rewards: Maybe<ReadonlyArray<(
      { readonly __typename?: 'Reward' }
      & IRewardFragment
    )>> }> };

export type ILoyaltyUserOffersQueryVariables = {
  loyaltyId: Scalars['ID'],
  where?: Maybe<IOffersInput>
};


export type ILoyaltyUserOffersQuery = { readonly __typename?: 'Query', readonly loyaltyUser: Maybe<{ readonly __typename?: 'User', readonly id: string, readonly offers: Maybe<ReadonlyArray<(
      { readonly __typename?: 'Offer' }
      & IOffersFragment
    )>> }> };

export type ILoyaltyOffersQueryVariables = {
  ids?: Maybe<ReadonlyArray<Scalars['ID']>>,
  loyaltyId?: Maybe<Scalars['ID']>,
  serviceMode?: Maybe<ServiceMode>,
  storeId?: Maybe<Scalars['String']>,
  subtotalAmount?: Maybe<Scalars['Int']>
};


export type ILoyaltyOffersQuery = { readonly __typename?: 'Query', readonly loyaltyOffers: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Offer' }
    & IOffersFragment
  )>> };

export type ILoyaltyEngineRewardsQueryVariables = {
  loyaltyId: Scalars['ID']
};


export type ILoyaltyEngineRewardsQuery = { readonly __typename?: 'Query', readonly loyaltyRewards: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Reward' }
    & IRewardFragment
  )>> };

export type ILoyaltyNotificationsRedeemableQueryVariables = {
  loyaltyId: Scalars['ID'],
  rewardsInput?: Maybe<IRewardsInput>,
  offersInput?: Maybe<IOffersInput>
};


export type ILoyaltyNotificationsRedeemableQuery = { readonly __typename?: 'Query', readonly loyaltyUser: Maybe<{ readonly __typename?: 'User', readonly id: string, readonly rewards: Maybe<ReadonlyArray<{ readonly __typename?: 'Reward', readonly id: string }>>, readonly promotions: Maybe<ReadonlyArray<{ readonly __typename?: 'SystemWidePromotion', readonly id: string }>>, readonly offers: Maybe<ReadonlyArray<{ readonly __typename?: 'Offer', readonly id: string }>> }> };

export type ILoyaltyGenerateOtpMutationVariables = {
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>,
  loyaltyId: Scalars['ID'],
  restaurantId?: Maybe<Scalars['ID']>
};


export type ILoyaltyGenerateOtpMutation = { readonly __typename?: 'Mutation', readonly generateOtp: { readonly __typename?: 'Otp', readonly password: string } };

export type IProcessSmgCodeMutationVariables = {
  loyaltyId: Scalars['ID'],
  smgCode: Scalars['String']
};


export type IProcessSmgCodeMutation = { readonly __typename?: 'Mutation', readonly processSmgCode: { readonly __typename?: 'ProcessSmgCodeResponse', readonly pointsEarned: number, readonly status: SmgCodeStatus } };

export type IOrderSelectionQueryVariables = {
  otp: Scalars['String']
};


export type IOrderSelectionQuery = { readonly __typename?: 'Query', readonly orderSelection: Maybe<{ readonly __typename?: 'OrderSelectionTransfer', readonly status: Maybe<OrderSelectionStatus>, readonly expiry: Maybe<number>, readonly _id: Maybe<string> }> };

export type ILoyaltyUserIncentiveEvaluationQueryVariables = {
  loyaltyId: Scalars['ID'],
  where: IEvaluateIncentivesInput
};


export type ILoyaltyUserIncentiveEvaluationQuery = { readonly __typename?: 'Query', readonly loyaltyUser: Maybe<{ readonly __typename?: 'User', readonly id: string, readonly evaluatedIncentives: { readonly __typename?: 'EvaluatedIncentives', readonly invalidOffers: ReadonlyArray<(
        { readonly __typename?: 'InvalidIncentives' }
        & IInvalidIncentiveFragment
      )>, readonly invalidRewards: ReadonlyArray<(
        { readonly __typename?: 'InvalidIncentives' }
        & IInvalidIncentiveFragment
      )> } }> };

export type IPromotionValidatePromoCodeMutationVariables = {
  code: Scalars['String'],
  cognitoId: Scalars['String'],
  shouldRedeem?: Maybe<Scalars['Boolean']>,
  offers: ReadonlyArray<Scalars['String']>
};


export type IPromotionValidatePromoCodeMutation = { readonly __typename?: 'Mutation', readonly validatePromoCode: Maybe<{ readonly __typename?: 'Coupon', readonly code: string, readonly reason: Maybe<string>, readonly message: string, readonly isValid: boolean, readonly isRedeemed: Maybe<boolean>, readonly offerId: Maybe<string> }> };

export type IPromotionRedeemPromoCodeMutationVariables = {
  code: Scalars['String'],
  cognitoId: Scalars['String']
};


export type IPromotionRedeemPromoCodeMutation = { readonly __typename?: 'Mutation', readonly redeemPromoCode: Maybe<{ readonly __typename?: 'RedeemedCoupon', readonly code: string, readonly reason: Maybe<string>, readonly message: Maybe<string>, readonly isRedeemed: boolean, readonly offerId: Maybe<string> }> };

export const TransactionFragmentFragmentDoc = gql`
    fragment TransactionFragment on Transaction {
  id
  shortId
  loyaltyId
  channel
  pointsEarned
  bonusPointsEarned
  pointsUsed
  transactionDetails {
    currency
    language
    promotions {
      type
      id
    }
    orders {
      productId
      quantity
      price
      parentReferenceId
    }
    fulfillment {
      type
      autoRelease
    }
    posVendor {
      id
      type
      transactionId
    }
    pickupContact {
      name
      phone
      hasArrived
      vehicle {
        make
        model
        color
        licensePlate
      }
    }
    payments {
      amount
      description
      type
      token
      expiration {
        month
        year
      }
    }
    person {
      externalIds {
        type
        value
      }
      phone
      email
    }
  }
  status
  createdAt
  dateUpdated
  additionalReferenceIds {
    id
    type
    description
  }
}
    `;
export const RewardFragmentFragmentDoc = gql`
    fragment RewardFragment on Reward {
  id
  rewardBenefitId
  name
  pointCost
  metadata {
    key
    value
  }
  createdAt
  updatedAt
  startDate
  endDate
  locked
  redemptionPercentage
  limitPerOrder
  remainingPointsNeededForRedemption
}
    `;
export const LoyaltyUserFragmentFragmentDoc = gql`
    fragment LoyaltyUserFragment on User {
  id
  name
  email
  phoneNumber
  dateOfBirth
  points
  metadata {
    key
    value
  }
  createdAt
  bestPromotion {
    metadata
  }
  pointsExpiryDateKey
}
    `;
export const OffersFragmentFragmentDoc = gql`
    fragment OffersFragment on Offer {
  id
  type
  benefits {
    type
    ... on BenefitReference {
      reference: value
    }
    ... on BenefitSwap {
      value {
        ... on Swap {
          type
          from
          to
        }
      }
    }
  }
}
    `;
export const InvalidIncentiveFragmentFragmentDoc = gql`
    fragment InvalidIncentiveFragment on InvalidIncentives {
  errors {
    code
    currentValue
    message
    ruleId
    targetValue
  }
  id
}
    `;
export const UpsellRecommendationsDocument = gql`
    query UpsellRecommendations($limit: Int, $products: [RecommendationProducts!]!, $storeId: String!, $serviceMode: String!, $type: RecommendationType!) @authRequired @gateway {
  upsellRecommendations(limit: $limit, products: $products, type: $type, storeId: $storeId, serviceMode: $serviceMode) {
    recommender
    recommendationToken
    results {
      id
    }
  }
}
    `;

/**
 * __useUpsellRecommendationsQuery__
 *
 * To run a query within a React component, call `useUpsellRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpsellRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpsellRecommendationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      products: // value for 'products'
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpsellRecommendationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>) {
        return ApolloReactHooks.useQuery<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>(UpsellRecommendationsDocument, baseOptions);
      }
export function useUpsellRecommendationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>(UpsellRecommendationsDocument, baseOptions);
        }
export type UpsellRecommendationsQueryHookResult = ReturnType<typeof useUpsellRecommendationsQuery>;
export type UpsellRecommendationsLazyQueryHookResult = ReturnType<typeof useUpsellRecommendationsLazyQuery>;
export type UpsellRecommendationsQueryResult = ApolloReactCommon.QueryResult<IUpsellRecommendationsQuery, IUpsellRecommendationsQueryVariables>;
export const LoyaltyUserDocument = gql`
    query LoyaltyUser($loyaltyId: ID!) @gateway {
  loyaltyUser(loyaltyId: $loyaltyId) {
    ...LoyaltyUserFragment
  }
}
    ${LoyaltyUserFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>(LoyaltyUserDocument, baseOptions);
      }
export function useLoyaltyUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>(LoyaltyUserDocument, baseOptions);
        }
export type LoyaltyUserQueryHookResult = ReturnType<typeof useLoyaltyUserQuery>;
export type LoyaltyUserLazyQueryHookResult = ReturnType<typeof useLoyaltyUserLazyQuery>;
export type LoyaltyUserQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>;
export const LoyaltyUserTransactionsDocument = gql`
    query LoyaltyUserTransactions($loyaltyId: ID!) @gateway {
  loyaltyUser(loyaltyId: $loyaltyId) {
    id
    transactions(where: {statuses: [CLAIMED, PENDING]}) {
      ...TransactionFragment
    }
  }
}
    ${TransactionFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserTransactionsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserTransactionsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUserTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>(LoyaltyUserTransactionsDocument, baseOptions);
      }
export function useLoyaltyUserTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>(LoyaltyUserTransactionsDocument, baseOptions);
        }
export type LoyaltyUserTransactionsQueryHookResult = ReturnType<typeof useLoyaltyUserTransactionsQuery>;
export type LoyaltyUserTransactionsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserTransactionsLazyQuery>;
export type LoyaltyUserTransactionsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>;
export const LoyaltyUserRewardsDocument = gql`
    query LoyaltyUserRewards($loyaltyId: ID!, $where: RewardsInput) @gateway {
  loyaltyUser(loyaltyId: $loyaltyId) {
    id
    rewards(where: $where) {
      ...RewardFragment
    }
  }
}
    ${RewardFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserRewardsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>(LoyaltyUserRewardsDocument, baseOptions);
      }
export function useLoyaltyUserRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>(LoyaltyUserRewardsDocument, baseOptions);
        }
export type LoyaltyUserRewardsQueryHookResult = ReturnType<typeof useLoyaltyUserRewardsQuery>;
export type LoyaltyUserRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserRewardsLazyQuery>;
export type LoyaltyUserRewardsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>;
export const LoyaltyUserOffersDocument = gql`
    query LoyaltyUserOffers($loyaltyId: ID!, $where: OffersInput) @gateway {
  loyaltyUser(loyaltyId: $loyaltyId) {
    id
    offers(where: $where) {
      ...OffersFragment
    }
  }
}
    ${OffersFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserOffersQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>(LoyaltyUserOffersDocument, baseOptions);
      }
export function useLoyaltyUserOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>(LoyaltyUserOffersDocument, baseOptions);
        }
export type LoyaltyUserOffersQueryHookResult = ReturnType<typeof useLoyaltyUserOffersQuery>;
export type LoyaltyUserOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyUserOffersLazyQuery>;
export type LoyaltyUserOffersQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>;
export const LoyaltyOffersDocument = gql`
    query LoyaltyOffers($ids: [ID!], $loyaltyId: ID, $serviceMode: ServiceMode, $storeId: String, $subtotalAmount: Int) @gateway {
  loyaltyOffers(ids: $ids, loyaltyId: $loyaltyId, serviceMode: $serviceMode, storeId: $storeId, subtotalAmount: $subtotalAmount) {
    ...OffersFragment
  }
}
    ${OffersFragmentFragmentDoc}`;

/**
 * __useLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      loyaltyId: // value for 'loyaltyId'
 *      serviceMode: // value for 'serviceMode'
 *      storeId: // value for 'storeId'
 *      subtotalAmount: // value for 'subtotalAmount'
 *   },
 * });
 */
export function useLoyaltyOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>(LoyaltyOffersDocument, baseOptions);
      }
export function useLoyaltyOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>(LoyaltyOffersDocument, baseOptions);
        }
export type LoyaltyOffersQueryHookResult = ReturnType<typeof useLoyaltyOffersQuery>;
export type LoyaltyOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersLazyQuery>;
export type LoyaltyOffersQueryResult = ApolloReactCommon.QueryResult<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>;
export const LoyaltyEngineRewardsDocument = gql`
    query LoyaltyEngineRewards($loyaltyId: ID!) @gateway {
  loyaltyRewards(loyaltyId: $loyaltyId) {
    ...RewardFragment
  }
}
    ${RewardFragmentFragmentDoc}`;

/**
 * __useLoyaltyEngineRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyEngineRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyEngineRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyEngineRewardsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyEngineRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>(LoyaltyEngineRewardsDocument, baseOptions);
      }
export function useLoyaltyEngineRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>(LoyaltyEngineRewardsDocument, baseOptions);
        }
export type LoyaltyEngineRewardsQueryHookResult = ReturnType<typeof useLoyaltyEngineRewardsQuery>;
export type LoyaltyEngineRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyEngineRewardsLazyQuery>;
export type LoyaltyEngineRewardsQueryResult = ApolloReactCommon.QueryResult<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>;
export const LoyaltyNotificationsRedeemableDocument = gql`
    query LoyaltyNotificationsRedeemable($loyaltyId: ID!, $rewardsInput: RewardsInput, $offersInput: OffersInput) @gateway {
  loyaltyUser(loyaltyId: $loyaltyId) {
    id
    rewards(where: $rewardsInput) {
      id
    }
    promotions {
      id
    }
    offers(where: $offersInput) {
      id
    }
  }
}
    `;

/**
 * __useLoyaltyNotificationsRedeemableQuery__
 *
 * To run a query within a React component, call `useLoyaltyNotificationsRedeemableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyNotificationsRedeemableQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyNotificationsRedeemableQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      rewardsInput: // value for 'rewardsInput'
 *      offersInput: // value for 'offersInput'
 *   },
 * });
 */
export function useLoyaltyNotificationsRedeemableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>(LoyaltyNotificationsRedeemableDocument, baseOptions);
      }
export function useLoyaltyNotificationsRedeemableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>(LoyaltyNotificationsRedeemableDocument, baseOptions);
        }
export type LoyaltyNotificationsRedeemableQueryHookResult = ReturnType<typeof useLoyaltyNotificationsRedeemableQuery>;
export type LoyaltyNotificationsRedeemableLazyQueryHookResult = ReturnType<typeof useLoyaltyNotificationsRedeemableLazyQuery>;
export type LoyaltyNotificationsRedeemableQueryResult = ApolloReactCommon.QueryResult<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>;
export const LoyaltyGenerateOtpDocument = gql`
    mutation LoyaltyGenerateOtp($inRestaurantOrder: [InRestaurantOrderLineItem!]!, $loyaltyId: ID!, $restaurantId: ID) @gateway {
  generateOtp(inRestaurantOrder: $inRestaurantOrder, loyaltyId: $loyaltyId, restaurantId: $restaurantId) {
    password
  }
}
    `;
export type ILoyaltyGenerateOtpMutationFn = ApolloReactCommon.MutationFunction<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>;

/**
 * __useLoyaltyGenerateOtpMutation__
 *
 * To run a mutation, you first call `useLoyaltyGenerateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyGenerateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyGenerateOtpMutation, { data, loading, error }] = useLoyaltyGenerateOtpMutation({
 *   variables: {
 *      inRestaurantOrder: // value for 'inRestaurantOrder'
 *      loyaltyId: // value for 'loyaltyId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useLoyaltyGenerateOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>) {
        return ApolloReactHooks.useMutation<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>(LoyaltyGenerateOtpDocument, baseOptions);
      }
export type LoyaltyGenerateOtpMutationHookResult = ReturnType<typeof useLoyaltyGenerateOtpMutation>;
export type LoyaltyGenerateOtpMutationResult = ApolloReactCommon.MutationResult<ILoyaltyGenerateOtpMutation>;
export type LoyaltyGenerateOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>;
export const ProcessSmgCodeDocument = gql`
    mutation ProcessSmgCode($loyaltyId: ID!, $smgCode: String!) @gateway {
  processSmgCode(loyaltyId: $loyaltyId, smgCode: $smgCode) {
    pointsEarned
    status
  }
}
    `;
export type IProcessSmgCodeMutationFn = ApolloReactCommon.MutationFunction<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>;

/**
 * __useProcessSmgCodeMutation__
 *
 * To run a mutation, you first call `useProcessSmgCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessSmgCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processSmgCodeMutation, { data, loading, error }] = useProcessSmgCodeMutation({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      smgCode: // value for 'smgCode'
 *   },
 * });
 */
export function useProcessSmgCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>(ProcessSmgCodeDocument, baseOptions);
      }
export type ProcessSmgCodeMutationHookResult = ReturnType<typeof useProcessSmgCodeMutation>;
export type ProcessSmgCodeMutationResult = ApolloReactCommon.MutationResult<IProcessSmgCodeMutation>;
export type ProcessSmgCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>;
export const OrderSelectionDocument = gql`
    query orderSelection($otp: String!) @gateway {
  orderSelection(otp: $otp) {
    _id: loyaltyId
    status
    expiry
  }
}
    `;

/**
 * __useOrderSelectionQuery__
 *
 * To run a query within a React component, call `useOrderSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSelectionQuery({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useOrderSelectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IOrderSelectionQuery, IOrderSelectionQueryVariables>) {
        return ApolloReactHooks.useQuery<IOrderSelectionQuery, IOrderSelectionQueryVariables>(OrderSelectionDocument, baseOptions);
      }
export function useOrderSelectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IOrderSelectionQuery, IOrderSelectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IOrderSelectionQuery, IOrderSelectionQueryVariables>(OrderSelectionDocument, baseOptions);
        }
export type OrderSelectionQueryHookResult = ReturnType<typeof useOrderSelectionQuery>;
export type OrderSelectionLazyQueryHookResult = ReturnType<typeof useOrderSelectionLazyQuery>;
export type OrderSelectionQueryResult = ApolloReactCommon.QueryResult<IOrderSelectionQuery, IOrderSelectionQueryVariables>;
export const LoyaltyUserIncentiveEvaluationDocument = gql`
    query LoyaltyUserIncentiveEvaluation($loyaltyId: ID!, $where: EvaluateIncentivesInput!) @gateway {
  loyaltyUser(loyaltyId: $loyaltyId) {
    id
    evaluatedIncentives(where: $where) {
      invalidOffers {
        ...InvalidIncentiveFragment
      }
      invalidRewards {
        ...InvalidIncentiveFragment
      }
    }
  }
}
    ${InvalidIncentiveFragmentFragmentDoc}`;

/**
 * __useLoyaltyUserIncentiveEvaluationQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserIncentiveEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserIncentiveEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserIncentiveEvaluationQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserIncentiveEvaluationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyUserIncentiveEvaluationQuery, ILoyaltyUserIncentiveEvaluationQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyUserIncentiveEvaluationQuery, ILoyaltyUserIncentiveEvaluationQueryVariables>(LoyaltyUserIncentiveEvaluationDocument, baseOptions);
      }
export function useLoyaltyUserIncentiveEvaluationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyUserIncentiveEvaluationQuery, ILoyaltyUserIncentiveEvaluationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyUserIncentiveEvaluationQuery, ILoyaltyUserIncentiveEvaluationQueryVariables>(LoyaltyUserIncentiveEvaluationDocument, baseOptions);
        }
export type LoyaltyUserIncentiveEvaluationQueryHookResult = ReturnType<typeof useLoyaltyUserIncentiveEvaluationQuery>;
export type LoyaltyUserIncentiveEvaluationLazyQueryHookResult = ReturnType<typeof useLoyaltyUserIncentiveEvaluationLazyQuery>;
export type LoyaltyUserIncentiveEvaluationQueryResult = ApolloReactCommon.QueryResult<ILoyaltyUserIncentiveEvaluationQuery, ILoyaltyUserIncentiveEvaluationQueryVariables>;
export const PromotionValidatePromoCodeDocument = gql`
    mutation PromotionValidatePromoCode($code: String!, $cognitoId: String!, $shouldRedeem: Boolean, $offers: [String!]!) @gateway {
  validatePromoCode(code: $code, cognitoId: $cognitoId, shouldRedeem: $shouldRedeem, offers: $offers) {
    code
    reason
    message
    isValid
    isRedeemed
    offerId
  }
}
    `;
export type IPromotionValidatePromoCodeMutationFn = ApolloReactCommon.MutationFunction<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>;

/**
 * __usePromotionValidatePromoCodeMutation__
 *
 * To run a mutation, you first call `usePromotionValidatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionValidatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionValidatePromoCodeMutation, { data, loading, error }] = usePromotionValidatePromoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cognitoId: // value for 'cognitoId'
 *      shouldRedeem: // value for 'shouldRedeem'
 *      offers: // value for 'offers'
 *   },
 * });
 */
export function usePromotionValidatePromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>(PromotionValidatePromoCodeDocument, baseOptions);
      }
export type PromotionValidatePromoCodeMutationHookResult = ReturnType<typeof usePromotionValidatePromoCodeMutation>;
export type PromotionValidatePromoCodeMutationResult = ApolloReactCommon.MutationResult<IPromotionValidatePromoCodeMutation>;
export type PromotionValidatePromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>;
export const PromotionRedeemPromoCodeDocument = gql`
    mutation PromotionRedeemPromoCode($code: String!, $cognitoId: String!) @gateway {
  redeemPromoCode(code: $code, cognitoId: $cognitoId) {
    code
    reason
    message
    isRedeemed
    offerId
  }
}
    `;
export type IPromotionRedeemPromoCodeMutationFn = ApolloReactCommon.MutationFunction<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>;

/**
 * __usePromotionRedeemPromoCodeMutation__
 *
 * To run a mutation, you first call `usePromotionRedeemPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionRedeemPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionRedeemPromoCodeMutation, { data, loading, error }] = usePromotionRedeemPromoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cognitoId: // value for 'cognitoId'
 *   },
 * });
 */
export function usePromotionRedeemPromoCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>) {
        return ApolloReactHooks.useMutation<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>(PromotionRedeemPromoCodeDocument, baseOptions);
      }
export type PromotionRedeemPromoCodeMutationHookResult = ReturnType<typeof usePromotionRedeemPromoCodeMutation>;
export type PromotionRedeemPromoCodeMutationResult = ApolloReactCommon.MutationResult<IPromotionRedeemPromoCodeMutation>;
export type PromotionRedeemPromoCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>;